export default {"src":"/_next/static/media/Collaborative_hiring.68fd5a7c.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};